module.exports = __webpack_public_path__ + "38e67fec6763a44f418906e9d14d18eb.png";